/* crst-why-fx.js — page-specific FX for the Why CRST page.
   Relocated verbatim from the former monolith sections/crst-why.liquid inline <script>:
     1) scroll-reveal (fade-up on enter, honors data-delay + reduced-motion)
     2) the M8 "is your current power strip safe?" self-test
     3) the M7 community / UGC rail paging + lazy video embeds
   Document-scoped + run-once (window.__crstWhyFx) so every crst-why-* section can
   include it safely (multiple includes = one execution). Each sub-handler no-ops when
   its markup is absent, so it is harmless on sections that don't use it.

   NOTE: the M2/M4 teardown wipe-slider + tile lightbox are NOT here — they ship
   self-contained inside snippets/crst-compare-core.liquid. This file intentionally does
   NOT touch [data-compare], so it never double-binds that slider. (This is also why the
   Why page does not load the document-scoped crst-home-fx.js, whose [data-compare]
   handler WOULD collide with the snippet's own slider.) */
(function(){
  if(window.__crstWhyFx)return;window.__crstWhyFx=1;

  function init(){
    var root=document;

    /* scroll reveal — fade up on enter, honors data-delay + reduced-motion */
    (function(){
      var els=root.querySelectorAll('.reveal'); if(!els.length) return;
      if(window.matchMedia('(prefers-reduced-motion:reduce)').matches || !('IntersectionObserver' in window)){
        els.forEach(function(el){ el.classList.add('in'); }); return;
      }
      var io=new IntersectionObserver(function(ents){
        ents.forEach(function(en){
          if(!en.isIntersecting) return;
          var d=en.target.getAttribute('data-delay'); if(d) en.target.style.transitionDelay=d+'ms';
          en.target.classList.add('in'); io.unobserve(en.target);
        });
      },{threshold:0.08,rootMargin:'0px 0px -6% 0px'});
      /* First-fold backstop (mirrors crst-home-fx.js): anything at or near the fold
         reveals on load — the scroll gate otherwise leaves a just-below-the-fold module
         blank for the first ~120px of scrolling on fold-height viewports. */
      var vh=window.innerHeight||document.documentElement.clientHeight||0;
      els.forEach(function(el){
        var r=vh?el.getBoundingClientRect():null;
        if(r && r.top<vh*1.2 && r.bottom>-40){
          var d=el.getAttribute('data-delay'); if(d) el.style.transitionDelay=d+'ms';
          el.classList.add('in');
        } else {
          io.observe(el);
        }
      });
    })();

    /* M8 self-test — grade the strip the visitor owns, route to the right CTA */
    (function(){
      var stQs=root.querySelector('#stQs'); if(!stQs) return;
      var qs=[].slice.call(stQs.querySelectorAll('[data-q]'));
      var total=qs.length, answers={};
      var meter=root.querySelectorAll('#stMeter i');
      var result=root.querySelector('#stResult'),
          titleEl=root.querySelector('#stTitle'),
          textEl=root.querySelector('#stText'),
          countEl=root.querySelector('#stCount'),
          cta=root.querySelector('#stCta');
      qs.forEach(function(q,i){
        q.querySelectorAll('.st-opt').forEach(function(opt){
          opt.addEventListener('click',function(){
            q.querySelectorAll('.st-opt').forEach(function(o){ o.classList.remove('on'); });
            opt.classList.add('on');
            answers[i]=opt.getAttribute('data-v');
            if(meter[i]) meter[i].className=opt.getAttribute('data-v');
            render();
          });
        });
      });
      function render(){
        var keys=Object.keys(answers), n=keys.length;
        var vals=keys.map(function(k){ return answers[k]; });
        var noCount=vals.filter(function(v){ return v==='no'; }).length;
        var unsureCount=vals.filter(function(v){ return v==='unsure'; }).length;
        countEl.innerHTML='<b>'+n+'</b> of '+total+' answered';
        result.classList.remove('state-idle','state-gap','state-check','state-solid');
        if(n<total){
          result.classList.add('state-idle');
          titleEl.textContent='Keep going →';
          textEl.textContent='Answer all five for a full read. "Not sure" is a valid answer — it just means it’s worth a closer look.';
          return;
        }
        if(noCount>0){
          result.classList.add('state-gap');
          titleEl.textContent='That’s a real gap.';
          textEl.textContent='One or more answers point to a strip missing something that actually keeps it safe. Here’s a verified replacement built to every standard above.';
          cta.firstChild.textContent='Shop safe power strips ';
        } else if(unsureCount>0){
          result.classList.add('state-check');
          titleEl.textContent='Worth double-checking.';
          textEl.textContent='Nothing failed outright, but a few answers were unclear. Check the unit itself for the marks and ratings — and if you’d rather not guess, here’s a verified option.';
          cta.firstChild.textContent='Shop a verified option ';
        } else {
          result.classList.add('state-solid');
          titleEl.textContent='Looks solid.';
          textEl.textContent='You’ve got a properly built strip — certified, rated, and protected. Keep it, and replace it the moment it ever feels warm under load.';
          cta.firstChild.textContent='See the CRST lineup ';
        }
      }
    })();

    /* M7 community rail — prev/next paging + lazy video embeds */
    (function(){
      var rail=root.querySelector('[data-ugc-rail]');
      var prev=root.querySelector('[data-ugc-prev]'),next=root.querySelector('[data-ugc-next]');
      if(!rail){ if(prev)prev.style.display='none'; if(next)next.style.display='none'; return; }
      var rm=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
      function sync(){ var max=rail.scrollWidth-rail.clientWidth-4; if(prev)prev.disabled=rail.scrollLeft<=4; if(next)next.disabled=rail.scrollLeft>=max; }
      function step(dir){
        var from=rail.scrollLeft, to=Math.max(0,from+dir*rail.clientWidth*.85);
        if(rm){ rail.scrollLeft=to; sync(); return; }
        try{ rail.scrollTo({left:to,behavior:'smooth'}); }catch(e){ rail.scrollLeft=to; }
        /* smooth scrolling silently no-ops in some engines — verify movement, else jump */
        setTimeout(function(){ if(Math.abs(rail.scrollLeft-from)<2&&Math.abs(to-from)>2){ rail.scrollLeft=to; } sync(); },150);
        setTimeout(sync,500);
      }
      if(prev)prev.addEventListener('click',function(){ step(-1); });
      if(next)next.addEventListener('click',function(){ step(1); });
      rail.addEventListener('scroll',sync,{passive:true});
      window.addEventListener('resize',sync);
      sync();
      rail.addEventListener('click',function(e){
        var b=e.target.closest('[data-embed]'); if(!b) return;
        var f=document.createElement('iframe');
        f.src=b.getAttribute('data-embed');
        f.setAttribute('allow','autoplay; encrypted-media; picture-in-picture');
        f.setAttribute('allowfullscreen','');
        f.title=b.getAttribute('data-title')||'Community video';
        var m=b.closest('.ugc-media'); m.innerHTML=''; m.appendChild(f);
      });
    })();
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init);
  } else {
    init();
  }
})();
